import { useToastStore } from '@/store';

export default async () => {
  const toastStore = useToastStore();

  toastStore.$reset();
};
